import { type IIntegrationKey } from 'entities/Integrations/api/types'

export const MICROSERVICE_INTEGRATIONS: IIntegrationKey[] = ['salesforce']

export const NANGO_GOOGLE_INTEGRATION_KEYS: IIntegrationKey[] = ['google_sheet', 'google_doc']
